import * as React from 'react';
import { debounce } from '../../utils/debounce';
export var useIsFocusedNotPage = function () {
    var _a = React.useState(false), pageNotFocused = _a[0], setPageNotFocused = _a[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var setFocusedDebounced = React.useCallback(debounce(function (hidden) { return setPageNotFocused(hidden); }, 1000), []);
    var changeVisability = function () {
        switch (document.visibilityState) {
            case 'hidden':
                setFocusedDebounced(true);
                break;
            case 'visible':
                setFocusedDebounced(false);
                break;
        }
    };
    React.useEffect(function () {
        document.addEventListener('visibilitychange', changeVisability);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return pageNotFocused;
};
//# sourceMappingURL=index.js.map